import React from "react";
import "./Skeleton.scss";

interface SkeletonProps {
  type?: "text" | "title" | "avatar" | "thumbnail" | "table" | "card";
  width?: string | number;
  height?: string | number;
  className?: string;
  count?: number;
  circle?: boolean;
}

const Skeleton: React.FC<SkeletonProps> = ({
  type = "text",
  width,
  height,
  className = "",
  count = 1,
  circle = false,
}) => {
  const getSkeletonClass = () => {
    switch (type) {
      case "title":
        return "skeleton-title";
      case "avatar":
        return "skeleton-avatar";
      case "thumbnail":
        return "skeleton-thumbnail";
      case "table":
        return "skeleton-table";
      case "card":
        return "skeleton-card";
      default:
        return "skeleton-text";
    }
  };

  const getSkeletonStyle = () => {
    const style: React.CSSProperties = {};
    if (width) style.width = typeof width === "number" ? `${width}px` : width;
    if (height)
      style.height = typeof height === "number" ? `${height}px` : height;
    if (circle) style.borderRadius = "50%";
    return style;
  };

  const renderSkeleton = () => {
    const skeletonClass = getSkeletonClass();
    const skeletonStyle = getSkeletonStyle();

    switch (type) {
      case "table":
        return (
          <div className="skeleton-table-container">
            {[...Array(count)].map((_, index) => (
              <div key={index} className="skeleton-table-row">
                <div
                  className="skeleton skeleton-table-cell"
                  style={skeletonStyle}
                />
                <div
                  className="skeleton skeleton-table-cell"
                  style={skeletonStyle}
                />
                <div
                  className="skeleton skeleton-table-cell"
                  style={skeletonStyle}
                />
                <div
                  className="skeleton skeleton-table-cell"
                  style={skeletonStyle}
                />
              </div>
            ))}
          </div>
        );
      case "card":
        return (
          <div className="skeleton-card-container">
            {[...Array(count)].map((_, index) => (
              <div key={index} className="skeleton-card">
                <div
                  className="skeleton skeleton-card-image"
                  style={skeletonStyle}
                />
                <div className="skeleton-card-content">
                  <div className="skeleton skeleton-card-title" />
                  <div className="skeleton skeleton-card-text" />
                  <div className="skeleton skeleton-card-text" />
                </div>
              </div>
            ))}
          </div>
        );
      default:
        return [...Array(count)].map((_, index) => (
          <div
            key={index}
            className={`skeleton ${skeletonClass} ${className}`}
            style={skeletonStyle}
          />
        ));
    }
  };

  return <>{renderSkeleton()}</>;
};

export default Skeleton;
